// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"d15593fe9fc8ac7a95ed","293":"198668e2bc265e76be53"}[chunkId] + ".js";
};